import { render, staticRenderFns } from "./redirect-target.vue?vue&type=template&id=121e2772&"
import script from "./redirect-target.vue?vue&type=script&lang=js&"
export * from "./redirect-target.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports